import { convertDatetimeToStringFormat } from "./datetime-helper";
import { getTypeOf } from "./object-helper";

export function toDatetimeString(date: Date | string) {
  let formatedDateString = "";
  if (typeof date === "string") {
    date = new Date(date);
  }
  formatedDateString = date.toLocaleString().split(",")[0];
  return formatedDateString;
}

export function toThousandSeperatorNumber(input: number | string) {
  if (input) {
    return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return "0";
  }
}

export function shortString(input: any, length: number) {
  let output = (input || '').toString();
  if(length < output.length - 3){
    output = output.substring(0, length) + "...";
  }
  return output;
} 

export function autoFormatValueToString(input: any, format?: string) {
  let type = getTypeOf(input);
  let output = (input === undefined || input === null ? "" : input).toString();
  if (format) {
    if (input != undefined) {
      switch (format) {
        case "text":
        case "string": {
          output = input.toString();
          break;
        }
        case "date": {
          output = convertDatetimeToStringFormat(input, "DD/MM/YYYY");
          break;
        }
        case "datetime": {
          output = convertDatetimeToStringFormat(input, "DD/MM/YYYY HH:mm:ss");
          break;
        }
        case "number": {
          if (input != undefined) {
            if(typeof input === 'number'){
              input = Math.ceil(input);
            }
            output = input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          }
          break;
        }
        default:
          break;
      }
    }
  } else {
    switch (type) {
      case "datetime": {
        output = convertDatetimeToStringFormat(input, "DD/MM/YYYY HH:mm:ss");
        break;
      }
      case "string": {
        break;
      }
      case "number": {
        const phoneRegex = /^0[1-9]+/;
        const numberRegex = /^[0-9]+/;
        if (numberRegex.test(input)) {
          output = input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        break;
      }
      default:
        break;
    }
  }

  return output;
}
